import React, { useState, FormEvent, useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Stack, Paper, Container } from '@mui/material'
import ProgressButton from '../../Utils/ProgressButton'
import { entityTextField } from '../../Utils/EntityField'
import { AppState } from '../../../reducers/index'
import { ProductSectionDetailState } from '../../../reducers/product/productSectionDetail'
import { upsertProductSection } from '../../../actions/product/productSectionUpsert'
import ProductSection from '../../../models/ProductSection'
import { useTranslation } from 'react-i18next'
import { ISTableTitle } from '../../Utils/ISTable'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { fetchProductSection } from '../../../actions/product/productSectionDetail'
import { BackButton } from '../../Utils/BackButton'
import Selector from '../../Selector'
import { isNil } from 'ramda'

interface Props {
  productSection: ProductSectionDetailState
}

const empty: ProductSection = {
  id: null,
  code: '',
  description: '',
  order: 0,
  ownerId: 0,
  ownerName: '',
  active: true
}

const ProductSectionUpsert: React.FC<Props> = ({ productSection }) => {
  const [changed, setChanged] = useState<boolean>(false)
  const [productSectionInfo, setProductSectionInfo] = useState<ProductSection>(productSection.productSection || empty)
  const { t } = useTranslation('product')
  const dispatch = useDispatch()
  const params = useParams<{ productSectionId: string }>()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (params.productSectionId) {
      dispatch(fetchProductSection(params.productSectionId))
    }
  }, [dispatch, params.productSectionId])


  const change = (newProductSectionInfo: ProductSection) => {
    setProductSectionInfo(newProductSectionInfo)
    setChanged(true)
  }

  const changeProductSection = async (event: FormEvent) => {
    event.preventDefault()
    try {
      await dispatch(upsertProductSection(productSectionInfo))
      setChanged(false)
      if (location.state)
        (location.state as any).update = !(location.state as any).update
      history.goBack()
    }
    catch {
    }
  }

  useEffect(() => {
    if (productSection.productSection) {
      setProductSectionInfo(params.productSectionId ? productSection.productSection : empty)
    }
  }, [productSection.productSection, params.productSectionId])

  const ProductSectionInfoField = useMemo(() => entityTextField(change), [])

  return (
    <Container>
      <Paper style={{ borderRadius: "10px", margin: "10px" }}>
        <ISTableTitle title={t('sections')} />
        <Paper style={{ padding: "10px" }}>
          <form onSubmit={changeProductSection}>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ProductSectionInfoField
                style={{ width: "200px", marginRight: "10px" }}
                key="code"
                variant="outlined"
                label={t("code")}
                entity={productSectionInfo}
                attr="code"
                size="medium"
              />
              <ProductSectionInfoField
                //style={{ width: "100%"}}
                key="description"
                variant="outlined"
                label={t("description")}
                entity={productSectionInfo}
                attr="description"
                size="medium"
              />
            </Stack>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ProductSectionInfoField
                style={{ marginRight: "10px" }}
                key="order"
                variant="outlined"
                label={t("order")}
                entity={productSectionInfo}
                attr='order'
                size="medium"
              />
              <Selector
                key="active"
                label={t("active")}
                style={{ width: "100%" }}
                value={isNil(productSectionInfo.active) ? "" : Boolean(productSectionInfo.active)}
                textAdapter={(_value) => Boolean(_value) ? t("yes") : t("no")}
                menuItems={[true, false]}
              />
            </Stack>
            <Stack display="flex" flexDirection='row' justifyContent="space-between">
              <BackButton />
              <ProgressButton state={productSection} disabled={!changed}>
                {t('save')}
              </ProgressButton>
            </Stack>
          </form>
        </Paper>
      </Paper>
    </Container>

  )
}

const mapStateToProps = (state: AppState) => ({
  productSection: state.productSectionDetail
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(ProductSectionUpsert)
